import { useTemplateState } from './context/VideoTemplateStateContext';
import { getMediaLayer, MediaLayerResult } from './state';

interface UseMediaLayerConfig {
  layerId: string;
}

const useMediaLayer = (config: UseMediaLayerConfig): MediaLayerResult => {
  const { layerId } = config;

  return getMediaLayer(useTemplateState(), layerId);
};

export default useMediaLayer;
